/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Storage_LabelInputs */

const en_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage & Delivery:`)
};

const fr_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage et livraison :`)
};

const de_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagerung & Lieferung:`)
};

const it_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoccaggio e consegna:`)
};

const ru_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранение и доставка:`)
};

const es_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento y entrega:`)
};

const zh_cn2_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仓储与配送：`)
};

const ja_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管と配送:`)
};

const hi_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भंडारण और वितरण:`)
};

const pt_pt2_embed_captions_pricing_storage_label = /** @type {(inputs: Embed_Captions_Pricing_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento e entrega:`)
};

/**
* | output |
* | --- |
* | "Storage & Delivery:" |
*
* @param {Embed_Captions_Pricing_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_storage_label = /** @type {((inputs?: Embed_Captions_Pricing_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_pricing_storage_label(inputs)
	if (locale === "de") return de_embed_captions_pricing_storage_label(inputs)
	if (locale === "it") return it_embed_captions_pricing_storage_label(inputs)
	if (locale === "ru") return ru_embed_captions_pricing_storage_label(inputs)
	if (locale === "es") return es_embed_captions_pricing_storage_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_pricing_storage_label(inputs)
	if (locale === "ja") return ja_embed_captions_pricing_storage_label(inputs)
	if (locale === "hi") return hi_embed_captions_pricing_storage_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_pricing_storage_label(inputs)
	return en_embed_captions_pricing_storage_label(inputs)
});